var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-5 text-center"},[_vm._v("Login")]),_c('div',{staticClass:"pt-5"},[_c('sign-in2-form',{attrs:{"formType":"jwt","email":"admin@findash.com","password":"admin123"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }